import React from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import { withLastLocation } from "react-router-last-location";

import { apiError, dataNotAvailable, saveYearData, saveMonthData, saveDayData, saveHourData, setPolling, saveBillingCyclePeriod, changeMode, setPropsForCostOrConsumptionValues, changeGraphStyle, toggleFilterFropdown, toggleGasElectric, toggleCostEnergy, toggleWeather, setInsightsHighchartsData, changeYearOffset, changeMonthOffset, changeDayOffset, changeHourOffset, setArrowDisabled, fetchMonthBillingCycleFromYear, fetchDayBillingCycleFromMonth, fetchHourBillingCycleFromDay, updateHighChartsObject, setHasOngoingBillingCycle, setHasItemizationUnavailable, setHasMissingInterval, removeDisclaimers, setDisclaimersVisibility } from '../../../../actions/insightsBillUsageActions';
import { trackEvent } from '../../../../helpers/analyticsHelper';
import { fetchBillUsageData, fetchHourData } from '../../../../dataFetchers/insightsPageDataFetcher';
import { checkIfArrayOfZeroes, fetchBillingCycleDateBoundaries, getDataNotAvailableText, setUsageChartDataForYear, setUsageChartDataForMonth, setUsageChartDataForDay, setUsageChartDataForHour, setTooltip, checkIfDataEmpty, createVariableFromApplianceName } from '../../../../helpers/UsageDashboardHelper';
import InsightsUsage from "./InsightsUsage";

import { NONE, INSIGHTS_PAGES, EVENT_NAMES, PAGE_EVENT_NAMES, USAGE_COLORS, TEMPERATURE, BAR_COLOR, BAR_HOVER_COLOR, NA, ONGOING, INSIGHTS_USAGE_COLORS, USAGE_CHART_EVENTS, UNITS, TIMESCALE, FUEL_TYPE, USAGE_TYPE, USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW, ARROWS, USAGE_DASHBOARD_Hour_ITEMS_TO_SHOW, GRAPH_STYLE, BUDGET_THRESHOLD_AMOUNT, HOUR_APPLIANCES_LIST_NAME, HOUR_APPLIANCES_LIST_COLOR, POLLING_TIME} from '../../../../constants/common';
import { Configuration } from '../../../../configs/Configuration';
import { displayUsage, displayCost } from '../../../../helpers/helper';

class InsightsUsageContainer extends React.Component {
    configColors = Configuration.getColors().colors;
    intervalFunc = null;
    componentDidMount() {

        //call function to fetch data
        if (this.props.insightsBillUsageData.insightsUsageHighChartsData.length === 0) {
            this.fetchItemizationData();
        } else {
            this.setGraphOptions();
        }

        //Modify cost/consumption view and default mode for it
        let mode = this.props.insightsBillUsageData.mode;
        let params = {
            showCostConsumptionToggle: this.props.configs.data[`showCostConsumptionSwitch${mode}`] === 'true',
            switchGasElectric: this.props.configs.data['fuelType'],
            usageChartEvent: USAGE_CHART_EVENTS.SET_PROPS_FOR_COST_OR_CONSUMPTION
        };
        if (this.props.configs.data[`defaultCostConsumption${mode}`] && this.props.configs.data[`defaultCostConsumption${mode}`] !== NONE){
            params.switchCostEnergy = this.props.configs.data[`defaultCostConsumption${mode}`].toLowerCase() === USAGE_TYPE.COST.toLowerCase() ? USAGE_TYPE.COST : USAGE_TYPE.ENERGY;
        }
        this.props.setPropsForCostOrConsumptionValues(params);

        //call analytics function to save viewed event
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            viewed: true,
            dashboardView: this.props.configs.data['fuelType'],
            shown: INSIGHTS_PAGES.USAGE
        }, this.props)
    }

    componentDidUpdate(prevProps) {
        if(this.props.insightsBillUsageData.mode !== prevProps.insightsBillUsageData.mode) {
            clearInterval(this.intervalFunc);
        }

        // If user changes between COST ad ENERGY, BAR GRAPH and AREA GRAPH or shows/hides WEATHER, re-render highcharts
        if ([USAGE_CHART_EVENTS.TOGGLE_COST_ENERGY, USAGE_CHART_EVENTS.CHANGE_GRAPH_STYLE, USAGE_CHART_EVENTS.TOGGLE_WEATHER].indexOf(this.props.insightsBillUsageData.usageChartEvent) !== -1) {
            this.setGraphOptions();
        }

        //After changing year/month/day or gas/electric, call api
        if ([USAGE_CHART_EVENTS.CHANGE_MODE, USAGE_CHART_EVENTS.TOGGLE_GAS_ELECTRIC, USAGE_CHART_EVENTS.CHANGE_MONTH_OFFSET, USAGE_CHART_EVENTS.CHANGE_DAY_OFFSET].indexOf(this.props.insightsBillUsageData.usageChartEvent) !== -1) {
            clearInterval(this.intervalFunc);
            this.fetchItemizationData();
        }

        if (this.props.insightsBillUsageData.usageChartEvent === USAGE_CHART_EVENTS.SET_HIGHCHARTS_DATA) {
            this.checkIfDataEmpty();
            this.updateHighChartsObject();
            this.setBillingCyclesInfo();
        }

        if (this.props.insightsBillUsageData.usageChartEvent === USAGE_CHART_EVENTS.CHANGE_YEAR_OFFSET) {
            this.props.setArrowDisabled({
                usageChartEvent: USAGE_CHART_EVENTS.CHECK_ARROW_DISABLED,
                insightsDataLeftArrowDisabled: (this.props.insightsBillUsageData.datasYearIndexOffset >= this.props.insightsBillUsageData.dataXAxis.length - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW),
                insightsDataRightArrowDisabled: (this.props.insightsBillUsageData.datasYearIndexOffset === 0)
            });
            this.setGraphOptions();
        }

        if (this.props.insightsBillUsageData.usageChartEvent === USAGE_CHART_EVENTS.CHANGE_HOUR_OFFSET) {
            this.props.setArrowDisabled({
                usageChartEvent: USAGE_CHART_EVENTS.CHECK_ARROW_DISABLED,
                isPollingHourData: this.props.insightsBillUsageData.insightsDataRightArrowDisabled ?  true : false,
            });
            this.fetchItemizationData();
        }

        if (this.props.insightsBillUsageData.usageChartEvent === USAGE_CHART_EVENTS.FETCH_MONTH_FROM_YEAR) {
            this.onModeChange(TIMESCALE.MONTH);
        }

        if (this.props.insightsBillUsageData.usageChartEvent === USAGE_CHART_EVENTS.FETCH_DATE_FROM_MONTH) {
            this.onModeChange(TIMESCALE.DAY);
        }

        if(this.props.insightsBillUsageData.usageChartEvent === USAGE_CHART_EVENTS.FETCH_HOUR_FROM_DAY) {
            this.onModeChange(TIMESCALE.HOUR);
        }
    }

    fetchBillUsageDataFunc() {
        let dateParams = fetchBillingCycleDateBoundaries(this.props.insightsBillUsageData);
        fetchBillUsageData({
            "measurement-type": this.props.configs.data['fuelType'].toUpperCase(),
            "mode": this.props.insightsBillUsageData.mode.toLowerCase(),
            "start": dateParams.start,
            "end": dateParams.end,
            "date-format": dateParams.dateFormat
        }, this.props.userIdentityDetails.userId).then( (res) => {
            if (res && res.data && res.data.payload) {
                this.setHighchartsData(res);
            }else {
                this.props.apiError();
            }
        });
    }

    itronApiCall(t0,t1,mode) {
        fetchHourData(t0,t1,mode).then( (res) => {
            if (res && res.data && res.data.payload) {
                this.setHighchartsData(res);
            }else {
                this.props.apiError();
            }
        });
    }

    setTimestampRangeForItron(eventTimestamp) {
        let t0 , t1 = 0;
        if(this.props.insightsBillUsageData.mode === TIMESCALE.HOUR) {
            let d = moment();
            if(eventTimestamp) {
                d = moment.unix(eventTimestamp);
            }
            let minHourStr = d.format("YYYY-MM-DD HH:00");
            t0 = moment(minHourStr, "YYYY-MM-DD HH:00").unix();
            d.add(1, 'hour');
            let maxHourStr = d.format("YYYY-MM-DD HH:00");
            t1 = moment(maxHourStr, "YYYY-MM-DD HH:00").unix();
        } else if(this.props.insightsBillUsageData.mode === TIMESCALE.DAY) {
            if(eventTimestamp) {
               let d = moment.unix(eventTimestamp);
                t0 = d.startOf('day').unix();
                t1 = d.endOf('day').unix();
            } else {
                t0 = moment().startOf('day').unix();
                t1 = moment().endOf('day').unix();
            }
        }
        if(this.props.insightsBillUsageData.isStoreHourEnd) {
            this.props.setPolling({
                storeDayDataforHour : t1,
                isStoreHourEnd : false
            });
        }
        return {
            minHour: t0,
            maxHour: t1
        }
    }

    HourItemization() {
        let dateParams = fetchBillingCycleDateBoundaries(this.props.insightsBillUsageData);
        let t0, t1 = 0;
        if(this.props.insightsBillUsageData.isDayToHourEvent) {
            let timestamp = this.setTimestampRangeForItron(dateParams.start)
            t0 = timestamp.minHour;
            t1 = timestamp.maxHour;
            this.itronApiCall(t0,t1,this.props.insightsBillUsageData.mode);
            if(this.props.insightsBillUsageData.isStoreHourEnd) {
                this.setTimestampRangeForItron();
            }
        } else {
            let hourRange = this.setTimestampRangeForItron();
            this.itronApiCall(hourRange.minHour, hourRange.maxHour,this.props.insightsBillUsageData.mode);
        }
    }

    fetchItemizationData() {
        //call api for data
        if(this.props.insightsBillUsageData.mode === TIMESCALE.HOUR || this.props.insightsBillUsageData.mode === TIMESCALE.DAY ) {
            this.HourItemization();
            //// 2 mins polling time for Hour and 10 mins for Day
            let pollingTime = this.props.insightsBillUsageData.mode === TIMESCALE.HOUR ? POLLING_TIME.HOUR : POLLING_TIME.DAY;
            /// polling is only start for current Date OR current Hour
            if((this.props.insightsBillUsageData.dataHourEnd == parseInt(this.props.insightsBillUsageData.storeDayDataforHour)) || (this.props.insightsBillUsageData.isPollingHourData) ||
            ((this.props.insightsBillUsageData.dataDayEnd - 1 ) == parseInt(this.props.insightsBillUsageData.storeDayDataforHour)) ) {
                this.intervalFunc = setInterval(() => this.HourItemization(), pollingTime);
            } else {
                clearInterval(this.intervalFunc);
            }
        } else {
            clearInterval(this.intervalFunc);
            this.fetchBillUsageDataFunc();
        }
    }

    componentWillUnmount() {
        if (this.intervalFunc) {
          clearInterval(this.intervalFunc);
        }
    }

    getYAxisDataFromHourApplianceList(data) {
        let params = {};
        let applianceList = Object.keys(HOUR_APPLIANCES_LIST_NAME);
        applianceList.push(NA.NAME, ONGOING.NAME);

        applianceList.forEach(appliance => {
            let energyVariableName = createVariableFromApplianceName(appliance, USAGE_TYPE.ENERGY);
            params[energyVariableName] = data[energyVariableName];
        });

        return params;
    }

    getYAxisDataFromApplianceList(data) {
        let params = {};
        let applianceList = Object.keys(this.props.applianceList);
        applianceList.push(NA.NAME, ONGOING.NAME);

        applianceList.forEach(appliance => {
            let costVariableName = createVariableFromApplianceName(appliance, USAGE_TYPE.COST);
            let energyVariableName = createVariableFromApplianceName(appliance, USAGE_TYPE.ENERGY);
            params[costVariableName] = data[costVariableName];
            params[energyVariableName] = data[energyVariableName];
        });

        return params;
    }

    setHighchartsData(res) {
        let graphApiData = null;
        this.props.removeDisclaimers();
        let translations = this.props.translations.data;

        //Filter out billing cycles which do not have itemization
        graphApiData = res.data.payload;
        //If no data is available
        if (graphApiData.length === 0) {
            let dataNotAvailableText = getDataNotAvailableText(this.props.insightsBillUsageData, translations);

            this.props.dataNotAvailable({
                usageChartEvent: USAGE_CHART_EVENTS.SHOW_DATA_NOT_AVAILABLE,
                dataNotAvailableText: dataNotAvailableText,
                isUsageChartBCLLoading: false,
                insightsDataLeftArrowDisabled: true,
                insightsDataRightArrowDisabled: true
            });
            return;
        }
        let dataXAxis = [], dataTemperature = [], dateStrings = [], totalHourData = [];

        dataXAxis = graphApiData.map( item => {
            //Push temperature to create array of temperatures to feed highcharts
            dataTemperature.push(item.temperature);
            totalHourData.push(item.consumption);

            //Push date string objects
            dateStrings.push({
                startDate: item.intervalStartDate,
                endDate: item.intervalEndDate
            });

            //Push dates in axis and billing cycle duration after modifying in moment to feed highcharts
            let xAxisDate;
            if(this.props.insightsBillUsageData.mode === TIMESCALE.HOUR) {
                xAxisDate = moment(this.props.insightsBillUsageData.mode === TIMESCALE.HOUR ? item.intervalEndDate : item.intervalStartDate).format('hh:mm');
            } else if(this.props.insightsBillUsageData.mode === TIMESCALE.DAY) {
                xAxisDate = moment(this.props.insightsBillUsageData.mode === TIMESCALE.DAY ? item.intervalEndDate : item.intervalStartDate).format('hh:mm A');
            } else {
                xAxisDate = moment(this.props.insightsBillUsageData.mode === TIMESCALE.YEAR ? item.intervalEndDate : item.intervalStartDate).format(this.props.configs.data[`DATE_FORMATS.${this.props.insightsBillUsageData.mode.toUpperCase()}.XAXIS`]);
            }

            //Check if exception and then put disclaimers
            if ((this.props.insightsBillUsageData.mode === TIMESCALE.YEAR && item.isOngoingInterval && item.itemizationDetailsList === null) || ((this.props.insightsBillUsageData.mode !== TIMESCALE.YEAR) && item.isOngoingInterval)) {
                xAxisDate += translations["DISCLAIMER_ICONS.USAGE.ICON1"];
                this.props.setHasOngoingBillingCycle();
            } else if ((item.cost || item.consumption) && item.itemizationDetailsList === null && this.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
                xAxisDate += translations["DISCLAIMER_ICONS.USAGE.ICON2"];
                this.props.setHasItemizationUnavailable();
            }else if (item.isMissingDataInterval) {
                xAxisDate += translations["DISCLAIMER_ICONS.USAGE.ICON3"];
                this.props.setHasMissingInterval();
            }
            return xAxisDate;
        });

        if (this.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
            let data = setUsageChartDataForYear(graphApiData, this.props.applianceList);

            //form Y Axis data from individual appliance datas
            let params = this.getYAxisDataFromApplianceList(data);

            this.props.saveYearData({
                usageChartEvent: USAGE_CHART_EVENTS.SAVE_YEAR_DATA,
                ...params,
                dataTimeStampsYear: data.dataTimeStampsYear,
                //If more than 13 items are present, enable the left arrow. On 1st time load in year mode, disable right arrow
                insightsDataRightArrowDisabled: true,
                insightsDataLeftArrowDisabled: (graphApiData.length <= USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW),
                //clear month billing cycle start and end
                dataMonthStart: 0,
                dataMonthEnd: 0,
                datasMonthIndex: data.dataTimeStampsYear.length - 1,
                dataTimeStampsMonth: [],
                //clear day billing cycle and end
                dataDayStart: 0,
                dataDayEnd: 0,
                dataTimeStampsDay: [],
                dataTemperature,
                dataXAxis,
                dateStrings,
                isDayToHourEvent: false
            });
        }else if (this.props.insightsBillUsageData.mode === TIMESCALE.MONTH) {
            let data = setUsageChartDataForMonth(graphApiData);

            this.props.saveMonthData({
                usageChartEvent: USAGE_CHART_EVENTS.SAVE_MONTH_DATA,
                ...data,
                dataDayStart: data.dataTimeStampsMonth[0].start,
                dataDayEnd: data.dataTimeStampsMonth[data.dataTimeStampsMonth.length - 1].end,
                insightsDataLeftArrowDisabled: this.props.insightsBillUsageData.datasMonthIndex === 0,
                insightsDataRightArrowDisabled: this.props.insightsBillUsageData.datasMonthIndex === (this.props.insightsBillUsageData.dataTimeStampsYear.length - 1),
                dataTemperature,
                dataXAxis,
                dataMonthStart: data.dataTimeStampsMonth[0].start,
                dataMonthEnd: data.dataTimeStampsMonth[data.dataTimeStampsMonth.length - 1].end,
                dateStrings,
                isDayToHourEvent: false
            });
        }else if (this.props.insightsBillUsageData.mode === TIMESCALE.DAY) {
            let data = setUsageChartDataForHour(graphApiData, HOUR_APPLIANCES_LIST_NAME);
            let params = this.getYAxisDataFromHourApplianceList(data);
            this.props.saveDayData({
                usageChartEvent: USAGE_CHART_EVENTS.SAVE_DAY_DATA,
                ...params,
                dataDayStart: data.dataTimeStampsHour[0].start,
                dataDayEnd: data.dataTimeStampsHour[data.dataTimeStampsHour.length - 1].end,
                dataDayCost: data.dataDayCost,
                dataDayEnergy: data.dataDayEnergy,
                dataTimeStampsDay: data.dataTimeStampsHour,
                insightsDataLeftArrowDisabled: (this.props.insightsBillUsageData.dataDayStart === this.props.insightsBillUsageData.dataTimeStampsYear[0].start),
                insightsDataRightArrowDisabled: ((data.dataTimeStampsHour[data.dataTimeStampsHour.length - 1].end) >= parseInt(this.props.insightsBillUsageData.storeDayDataforHour) ),
                dataTemperature,
                dataXAxis,
                dateStrings,
            });
        } else if (this.props.insightsBillUsageData.mode === TIMESCALE.HOUR) {
            let data = setUsageChartDataForHour(graphApiData, HOUR_APPLIANCES_LIST_NAME);
            //form Y Axis data from individual appliance datas
            let params = this.getYAxisDataFromHourApplianceList(data);
            this.props.saveHourData({
                usageChartEvent: USAGE_CHART_EVENTS.SAVE_HOUR_DATA,
                ...params,
                dataTimeStampsHour: data.dataTimeStampsHour,
                dataHourStart: data.dataTimeStampsHour[0].start,
                dataHourEnd: data.dataTimeStampsHour[data.dataTimeStampsHour.length - 1].end,
                dataDayStart: 0,
                dataDayEnd: 0,
                totalHourData: totalHourData,
                insightsDataLeftArrowDisabled: (parseInt(this.props.insightsBillUsageData.dataHourStart) === this.props.insightsBillUsageData.dataTimeStampsYear[0].start),
                insightsDataRightArrowDisabled: ((data.dataTimeStampsHour[data.dataTimeStampsHour.length - 1].end) >= parseInt(this.props.insightsBillUsageData.storeDayDataforHour) ),
                dataTemperature,
                dataXAxis,
                dateStrings
            });
        }
        //After initializing data to state variables, re-render graph
        this.setGraphOptions();
    }

    setBillingCyclesInfo() {
        //Set billing cycle duration text for highcharts
        let billingcyclePeriodInfo = '';
        let dateStrings = this.props.insightsBillUsageData.dateStrings;
        let mode = this.props.insightsBillUsageData.mode;
        let count = dateStrings.length;

        let dateFormat = this.props.configs.data[`DATE_FORMATS.${mode.toUpperCase()}.BILLING_CYCLE_DURATION`];

        // only for Hour we pass hard-coded dateformat ///////////////////
        if(mode === TIMESCALE.HOUR) {
            dateFormat = "hh:mm A";
        }

        if (mode === TIMESCALE.YEAR) {
            let offset = this.props.insightsBillUsageData.datasYearIndexOffset;
            dateStrings = count > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? dateStrings.slice(count - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - offset, count - offset) : dateStrings;
        }

        if(mode === TIMESCALE.HOUR) {
            billingcyclePeriodInfo = moment(dateStrings[0].startDate).format("DD MMM");
            billingcyclePeriodInfo += " - ";
            billingcyclePeriodInfo += moment(dateStrings[0].startDate).format(dateFormat);
        } else {
            billingcyclePeriodInfo = moment(dateStrings[0].startDate).format(dateFormat);
        }

        if([TIMESCALE.YEAR, TIMESCALE.MONTH].indexOf(mode) !== -1) {
            billingcyclePeriodInfo += (" - " + moment(dateStrings[dateStrings.length - 1].endDate).format(dateFormat));
        } else if(mode === TIMESCALE.HOUR) {
            billingcyclePeriodInfo += (" to " + moment(dateStrings[dateStrings.length - 1].endDate).format(dateFormat));
        }

        this.props.saveBillingCyclePeriod({
            usageChartEvent: USAGE_CHART_EVENTS.SAVE_BILLING_CYCLE_INFO,
            currentBillingCycleInfo: billingcyclePeriodInfo
        });
    }

    //If the highcharts data array contains all values as 0 then show data is not available
    checkIfDataEmpty() {
        //To check if the billing cycle has any data, filter out the temperature array
        let highchartsData = this.props.insightsBillUsageData.insightsUsageHighChartsData.filter(item => item.name !== TEMPERATURE.NAME);
        let translations = this.props.translations.data;
        if(checkIfDataEmpty(highchartsData)) {
            let dataEmptyText = getDataNotAvailableText(this.props.insightsBillUsageData, translations);
            this.props.dataNotAvailable({
                usageChartEvent: USAGE_CHART_EVENTS.SHOW_DATA_EMPTY,
                dataEmptyText: dataEmptyText,
                isUsageChartBCLLoading: false
            });
        }
    }

    onModeChange(mode) {
        //When user switches between year, month and day
        if (mode === this.props.insightsBillUsageData.mode) {
            return;
        }

        let params = {
            usageChartEvent: USAGE_CHART_EVENTS.CHANGE_MODE,
            mode: mode,
            datasYearIndexOffset: 0,
            isUsageChartBCLLoading: true,
            dataEmptyText: '',
            dataNotAvailableText: '',
            switchCostEnergy: (mode === TIMESCALE.HOUR || mode === TIMESCALE.DAY) ? USAGE_TYPE.ENERGY : this.props.insightsBillUsageData.switchCostEnergy,
            showWeather: mode === TIMESCALE.HOUR ? false  : this.props.insightsBillUsageData.showWeather,
            isStoreHourEnd: true
        };
        if (this.props.configs.data[`showCostConsumptionSwitch${mode}`]) {
            params.showCostConsumptionToggle = this.props.configs.data[`showCostConsumptionSwitch${mode}`] === 'true'
        }
        if (this.props.configs.data[`defaultCostConsumption${mode}`] && this.props.configs.data[`defaultCostConsumption${mode}`] !== NONE) {
            params.switchCostEnergy = this.props.configs.data[`defaultCostConsumption${mode}`].toLowerCase() === USAGE_TYPE.COST.toLowerCase() ? USAGE_TYPE.COST : USAGE_TYPE.ENERGY
        }
        this.props.changeMode(params);
    }

    onGraphStyleChange(style) {
        //When user switches between bar and area graph
        if (this.props.insightsBillUsageData.usageGraphStyle === style || this.props.insightsBillUsageData.dataNotAvailableText) {
            return;
        }
        this.props.changeGraphStyle({
            usageChartEvent: USAGE_CHART_EVENTS.CHANGE_GRAPH_STYLE,
            usageGraphStyle: style
        });
    }

    onToggleFilterDropdown(e) {
        //When user opens or cleses dropdown
        this.props.toggleFilterFropdown({
            usageChartEvent: USAGE_CHART_EVENTS.TOGGLE_DROPDOWN,
            filterDropdownEl: e ? e.currentTarget: e
        });
    }

    switchGasElectric() {
        return this.props.insightsBillUsageData.switchGasElectric === FUEL_TYPE.GAS ? FUEL_TYPE.ELECTRIC : FUEL_TYPE.GAS;
    }

    switchCostEnergy() {
        return this.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? USAGE_TYPE.ENERGY : USAGE_TYPE.COST;
    }

    onToggleGasElectric() {
        //When user switches between gas and electric
        let newGasElectricValue = this.switchGasElectric();

        //Track event when user clicks on cost energy toggle switch
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            shown: INSIGHTS_PAGES.USAGE,
            dashboardView: FUEL_TYPE.ELECTRIC,
            clicked: EVENT_NAMES.FUEL_TOGGLE,
            type: newGasElectricValue
        })

        this.props.toggleGasElectric({
            usageChartEvent: USAGE_CHART_EVENTS.TOGGLE_GAS_ELECTRIC,
            switchGasElectric: newGasElectricValue,
            isUsageChartBCLLoading: true,
            dataNotAvailableText: '',
            dataEmptyText: '',
        });
    }

    onToggleCostEnergy() {
        //When user switches between cost and energy
        let newCostEnergyValue = this.switchCostEnergy();

        //Track event when user clicks on cost energy toggle switch
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            shown: INSIGHTS_PAGES.USAGE,
            dashboardView: this.props.configs.data['fuelType'],
            clicked: EVENT_NAMES.USAGE_COST_TOGGLE,
            type: newCostEnergyValue
        })

        //Only if data not available text is empty i.e if payload is null i.e user is gas and checks for electric data or vice versa
        this.props.insightsBillUsageData.dataNotAvailableText.length === 0 && this.props.toggleCostEnergy({
            usageChartEvent: USAGE_CHART_EVENTS.TOGGLE_COST_ENERGY,
            switchCostEnergy: newCostEnergyValue,
            dataEmptyText: '',
            dataNotAvailableText: ''
        });
    }

    onToggleWeather() {
        //When user enables or disables weather
        //Track event when user clicks on cost energy toggle switch
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            shown: INSIGHTS_PAGES.USAGE,
            dashboardView: this.props.configs.data['fuelType'],
            clicked: EVENT_NAMES.WEATHER_TOGGLE,
            type: this.props.insightsBillUsageData.showWeather ? "off" : "on"
        })

        //Only if data not available text is empty i.e if payload is null i.e user is gas and checks for electric data or vice versa
        this.props.insightsBillUsageData.dataNotAvailableText.length === 0 && this.props.toggleWeather({
            usageChartEvent: USAGE_CHART_EVENTS.TOGGLE_WEATHER,
            showWeather: !this.props.insightsBillUsageData.showWeather
        })
    }

    setGraphOptions() {
        let insightsUsageHighChartsData = [];
        let translations = this.props.translations.data;

        let graphType = this.props.insightsBillUsageData.usageGraphStyle;

        if (this.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
            let keys = Object.keys(this.props.applianceList);

            //Check if any category doesn't have any value. If it has data, push to isnightsUsageHighChartsData to display
            keys.map(key => {
                let variableCost = createVariableFromApplianceName(key, USAGE_TYPE.COST);
                let variableEnergy = createVariableFromApplianceName(key, USAGE_TYPE.ENERGY);

                if (!checkIfArrayOfZeroes(this.props.insightsBillUsageData[variableCost])) {
                    insightsUsageHighChartsData.push({
                        name: this.props.applianceList[key],
                        type: graphType,
                        data: this.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? [...this.props.insightsBillUsageData[variableCost]] : [...this.props.insightsBillUsageData[variableEnergy]],
                        borderWidth: 0,
                        color: `rgb(${this.configColors[INSIGHTS_USAGE_COLORS[key]]})`
                    })
                }
            });

            //If there aren't any bilingCycles without itemization, do not push them
            if ( !checkIfArrayOfZeroes(this.props.insightsBillUsageData.dataNACost) ) {
                insightsUsageHighChartsData.push({
                    name: NA.NAME,
                    type: graphType,
                    data: this.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? [...this.props.insightsBillUsageData.dataNACost] : [...this.props.insightsBillUsageData.dataNAEnergy],
                    borderWidth: 0,
                    showInLegend: false,
                    color: `rgb(${this.configColors[NA.COLOR]})`
                });
            }

            insightsUsageHighChartsData.push({
                name: ONGOING.NAME,
                type: graphType,
                data: this.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? [...this.props.insightsBillUsageData.dataOngoingCost] : [...this.props.insightsBillUsageData.dataOngoingEnergy],
                borderWidth: 0,
                showInLegend: false,
                color: `rgb(${this.configColors[ONGOING.COLOR]})`
            });

            //Truncate data in year mode to return 13 items
            insightsUsageHighChartsData = insightsUsageHighChartsData.map( item => {
                let data = item.data;
                return {
                    ...item,
                    //If length is greater than 13, then show cropped data or else show entire data
                    data: data.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? data.slice(data.length - this.props.insightsBillUsageData.datasYearIndexOffset - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW, data.length - this.props.insightsBillUsageData.datasYearIndexOffset) : data
                };
            });

        }else if (this.props.insightsBillUsageData.mode === TIMESCALE.MONTH) {
            insightsUsageHighChartsData.push({
                name: translations["USAGE.TOTAL"],
                type: graphType,
                data: this.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? [...this.props.insightsBillUsageData.dataMonthCost] : [...this.props.insightsBillUsageData.dataMonthEnergy],
                borderWidth: 0,
                color: `rgb(${this.configColors[BAR_COLOR]})`,
                states: {
                    hover: {
                        color: `rgb(${this.configColors[BAR_HOVER_COLOR]})`
                    }
                }
            });
        } else if (this.props.insightsBillUsageData.mode === TIMESCALE.HOUR || this.props.insightsBillUsageData.mode === TIMESCALE.DAY) {
            let keys = Object.keys(HOUR_APPLIANCES_LIST_NAME);

            //Check if any category doesn't have any value. If it has data, push to isnightsUsageHighChartsData to display
            keys.map(key => {
                let variableEnergy = createVariableFromApplianceName(key, USAGE_TYPE.ENERGY);
                if (!checkIfArrayOfZeroes(this.props.insightsBillUsageData[variableEnergy])) {
                    insightsUsageHighChartsData.push({
                        name: HOUR_APPLIANCES_LIST_NAME[key],
                        type: graphType,
                        data: [...this.props.insightsBillUsageData[variableEnergy]],
                        borderWidth: 0,
                        color: HOUR_APPLIANCES_LIST_COLOR[key]
                    })
                } else {
                    insightsUsageHighChartsData.push({
                        name: HOUR_APPLIANCES_LIST_NAME[key],
                        type: graphType,
                        borderWidth: 0,
                        color: HOUR_APPLIANCES_LIST_COLOR[key]
                    });
                }
            });
            let checkEmptyData = ""
            for(let i = 0; i < insightsUsageHighChartsData.length; i++ ) {
                let test = insightsUsageHighChartsData[i];
                if(test.hasOwnProperty('data')) {
                    break;
                } else {
                    if(i == insightsUsageHighChartsData.length ) {
                        checkEmptyData =  "nodata";
                    }
                }
            }
            if(checkEmptyData == "nodata") {
                insightsUsageHighChartsData = [];
                this.checkIfDataEmpty();
            }
        }

        let datasYearIndexOffset = this.props.insightsBillUsageData.datasYearIndexOffset;

        //Check if temperature array has values and weather is enabled
        if (!checkIfArrayOfZeroes(this.props.insightsBillUsageData.dataTemperature) && this.props.insightsBillUsageData.showWeather) {
            let dataTemperature = this.props.insightsBillUsageData.dataTemperature;
            insightsUsageHighChartsData.push({
                name: TEMPERATURE.NAME,
                type: TEMPERATURE.GRAPH_STYLE,
                yAxis: 1,
                data: (this.props.insightsBillUsageData.mode === TIMESCALE.YEAR || this.props.insightsBillUsageData.mode === TIMESCALE.HOUR) && dataTemperature.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? dataTemperature.slice(dataTemperature.length - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - datasYearIndexOffset, dataTemperature.length - datasYearIndexOffset) : dataTemperature,
                marker: {
                    symbol: 'circle',
                    lineWidth: 2,
                    lineColor: `rgb(${this.configColors[TEMPERATURE.COLOR]})`,
                    fillColor: `rgb(${this.configColors[TEMPERATURE.FILL_COLOR]})`
                },
                color: `rgb(${this.configColors[TEMPERATURE.COLOR]})`
            });
        }

        let dataXAxisToShow = [...this.props.insightsBillUsageData.dataXAxis];
        dataXAxisToShow = this.props.insightsBillUsageData.mode === TIMESCALE.YEAR && dataXAxisToShow.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? dataXAxisToShow.slice(dataXAxisToShow.length - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - datasYearIndexOffset, dataXAxisToShow.length - datasYearIndexOffset) : dataXAxisToShow;
        this.checkIfDisplayDisclaimers(dataXAxisToShow);

        this.props.setInsightsHighchartsData({
            usageChartEvent: USAGE_CHART_EVENTS.SET_HIGHCHARTS_DATA,
            insightsUsageHighChartsData: insightsUsageHighChartsData
        });
    }

    checkIfDisplayDisclaimers(dataXAxis) {
        //From the list of x axis values displayed, check if any of the items have disclaimer icons and then show/hide the icons
        let showOngoingDisclaimer = false, showItemizationUnavailableDisclaimer = false, showDataNotAvailableDisclaimer = false;
        let translations = this.props.translations.data;
        for (let i = 0; i < dataXAxis.length; i++) {
            if (showOngoingDisclaimer && showDataNotAvailableDisclaimer && showDataNotAvailableDisclaimer) {
                break;
            }
            if (!showOngoingDisclaimer && dataXAxis[i].indexOf(translations["DISCLAIMER_ICONS.USAGE.ICON1"]) !== -1) {
                showOngoingDisclaimer = true;
            }
            if (!showItemizationUnavailableDisclaimer && dataXAxis[i].indexOf(translations["DISCLAIMER_ICONS.USAGE.ICON2"]) !== -1) {
                showItemizationUnavailableDisclaimer = true;
            }
            if (!showDataNotAvailableDisclaimer && dataXAxis[i].indexOf(translations["DISCLAIMER_ICONS.USAGE.ICON3"]) !== -1) {
                showDataNotAvailableDisclaimer = true;
            }
        }
        this.props.setDisclaimersVisibility({
            usageChartEvent: 'setDisclaimerVisibility',
            showOngoingDisclaimer: showOngoingDisclaimer,
            showItemizationUnavailableDisclaimer: showItemizationUnavailableDisclaimer,
            showDataNotAvailableDisclaimer: showDataNotAvailableDisclaimer
        });
    }

    changeDataToShowOffset(value) {
        let timestamps = [...this.props.insightsBillUsageData[`dataTimeStamps${this.props.insightsBillUsageData.mode}`]];
        if (this.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
            timestamps = timestamps.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? timestamps.slice(timestamps.length - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - this.props.insightsBillUsageData.datasYearIndexOffset, timestamps.length - this.props.insightsBillUsageData.datasYearIndexOffset) : timestamps;
            this.props.changeYearOffset({
                usageChartEvent: USAGE_CHART_EVENTS.CHANGE_YEAR_OFFSET,
                datasYearIndexOffset: (value === 1 ? this.props.insightsBillUsageData.datasYearIndexOffset + 1 : this.props.insightsBillUsageData.datasYearIndexOffset - 1)
            });
        }
        else{
            let payload = {
                isUsageChartBCLLoading: true,
                dataEmptyText: '',
                dataNotAvailableText: ''
            };

            if (this.props.insightsBillUsageData.mode === TIMESCALE.MONTH) {
                //Change billing cycle start and end after clicking arrows and then call api to fetch data in month mode with new start and end values
                this.props.changeMonthOffset({
                    usageChartEvent: USAGE_CHART_EVENTS.CHANGE_MONTH_OFFSET,
                    dataMonthStart: (value === -1 ? this.props.insightsBillUsageData.dataTimeStampsYear[this.props.insightsBillUsageData.datasMonthIndex + 1].start : this.props.insightsBillUsageData.dataTimeStampsYear[this.props.insightsBillUsageData.datasMonthIndex - 1].start),
                    dataMonthEnd: (value === -1 ? this.props.insightsBillUsageData.dataTimeStampsYear[this.props.insightsBillUsageData.datasMonthIndex + 1].end : this.props.insightsBillUsageData.dataTimeStampsYear[this.props.insightsBillUsageData.datasMonthIndex - 1].end),
                    datasMonthIndex: value === -1 ? this.props.insightsBillUsageData.datasMonthIndex + 1 : this.props.insightsBillUsageData.datasMonthIndex - 1,
                    ...payload
                })
            }else if (this.props.insightsBillUsageData.mode === TIMESCALE.DAY) {
                this.props.changeDayOffset({
                    usageChartEvent: USAGE_CHART_EVENTS.CHANGE_DAY_OFFSET,
                    isDayToHourEvent: true,
                    isPollingHourData : false,
                    dataDayStart: (value === 1 ? this.props.insightsBillUsageData.dataDayStart - 86400 : parseInt(this.props.insightsBillUsageData.dataDayEnd) ),
                    dataDayEnd: (value === 1 ? this.props.insightsBillUsageData.dataDayStart : parseInt(this.props.insightsBillUsageData.dataDayEnd )+ 86400 ),
                    ...payload
                })
            } else if (this.props.insightsBillUsageData.mode === TIMESCALE.HOUR) {
                this.props.changeHourOffset({
                    usageChartEvent: USAGE_CHART_EVENTS.CHANGE_HOUR_OFFSET,
                    isDayToHourEvent: true,
                    isPollingHourData : false,
                    dataHourStart: (value === 1 ? this.props.insightsBillUsageData.dataHourStart - 3600 : parseInt(this.props.insightsBillUsageData.dataHourEnd) ),
                    dataHourEnd: (value === 1 ? this.props.insightsBillUsageData.dataHourStart : parseInt(this.props.insightsBillUsageData.dataHourEnd) + 3600  ),
                    ...payload
                });
            }
        }

        // call analytics function to track arrow clicks
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            dashboardView: this.props.configs.data['fuelType'],
            shown: INSIGHTS_PAGES.USAGE,
            weather: this.props.insightsBillUsageData.showWeather,
            usageArrowClicked: value === 1 ? ARROWS.LEFT : ARROWS.RIGHT,
            intervalStart: timestamps[0].start,
            intervalEnd: timestamps[timestamps.length - 1].end
        })
    }

    fetchMonthBillingCycleFromYear(index) {
        //Fetch month start and end values from year billing cycles when clicked on year mode bars
        let arrayIndex = USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - 1 - index;
        let dataTimeStampsYear = [...this.props.insightsBillUsageData.dataTimeStampsYear];
        let datasMonthIndex = index;

        if (this.props.insightsBillUsageData.dataTimeStampsYear.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW) {
            datasMonthIndex = dataTimeStampsYear.length - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW + index - this.props.insightsBillUsageData.datasYearIndexOffset;
            dataTimeStampsYear = dataTimeStampsYear.reverse()[arrayIndex + this.props.insightsBillUsageData.datasYearIndexOffset];
        }else {
            dataTimeStampsYear = dataTimeStampsYear[index];
        }

        this.props.fetchMonthBillingCycleFromYear({
            usageChartEvent: USAGE_CHART_EVENTS.FETCH_MONTH_FROM_YEAR,
            dataMonthStart: dataTimeStampsYear.start,
            dataMonthEnd: dataTimeStampsYear.end,
            datasMonthIndex: datasMonthIndex
        })
    }


    fetchDateBillingCycleFromMonth(index) {
        //Fetch day start and end values from month billing cycles when clicked on month mode bars
        this.props.fetchDayBillingCycleFromMonth({
            usageChartEvent: USAGE_CHART_EVENTS.FETCH_DATE_FROM_MONTH,
            isDayToHourEvent: true,
            isPollingHourData : false,
            dataDayStart: this.props.insightsBillUsageData.dataTimeStampsMonth[index].start,
            dataDayEnd: this.props.insightsBillUsageData.dataTimeStampsMonth[index].end
        })
    }

    fetchDateBillingCycleFromDay(index) {
        //fetch hour start and end form day billing cycle when clicked pm day mode bars
        this.props.fetchHourBillingCycleFromDay({
            usageChartEvent: USAGE_CHART_EVENTS.FETCH_HOUR_FROM_DAY,
            dataHourStart: this.props.insightsBillUsageData.dataTimeStampsDay[index].start,
            dataHourEnd: this.props.insightsBillUsageData.dataTimeStampsDay[index].end,
            isDayToHourEvent: true,
            isPollingHourData : false,
        })
    }

    updateHighChartsObject() {
        let self = this;
        let dataXAxis = [...this.props.insightsBillUsageData.dataXAxis];
        let enableDrillDownInsightsUsage = this.props.configs.data.enableDrillDownInsightsUsage === 'true';

        dataXAxis = this.props.insightsBillUsageData.mode === TIMESCALE.YEAR && dataXAxis.length > USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW ? dataXAxis.slice(dataXAxis.length - USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW - this.props.insightsBillUsageData.datasYearIndexOffset, dataXAxis.length - this.props.insightsBillUsageData.datasYearIndexOffset) : dataXAxis;
        let YAxisPrimaryUnit = true;
        if(this.props.insightsBillUsageData.mode === TIMESCALE.HOUR ) {
            YAxisPrimaryUnit = false;
        }
        this.props.updateHighChartsObject({
            usageChartEvent: USAGE_CHART_EVENTS.UPDATE_HIGHCHARTS_OBJECT,
            options: {
                legend: {
                    itemStyle: {
                        color: `rgb(${this.configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`,
                        fontWeight: 'normal',
                    }
                },
                xAxis: [{
                    //If length is greater than 13, then show cropped data or else show entire data
                    categories: dataXAxis,
                    crosshair: true,
                    labels: {
                        formatter: function() {
                            let color = (self.props.insightsBillUsageData.mode === TIMESCALE.MONTH || TIMESCALE.HOUR && self.props.insightsBillUsageData.isWeekend[this.pos]) ? USAGE_COLORS.ITEMIZATION_WEEKEND_COLOR : USAGE_COLORS.ITEMIZATION_LEGEND_COLOR;
                            return `<span style="color: rgb(${self.configColors[color]})">${this.value}</span>`;
                        }
                    }
                }],
                yAxis: [{ // Primary yAxis
                    title: {
                        text: '',
                    },
                    labels: {
                        format: this.props.insightsBillUsageData.switchCostEnergy === USAGE_TYPE.COST ? (displayCost({cost: '{value}' , showCurrency: true})) : (displayUsage({usage: '{value}', showUsageUnit: YAxisPrimaryUnit , fuelType: this.props.insightsBillUsageData.switchGasElectric })),
                        style: {
                            color: `rgb(${this.configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`
                        }
                    }
                }, { // Secondary yAxis
                    title: {
                        text: '',
                    },
                    labels: {
                        format: '{value}' + ' ' +this.props.configs.data["weather_unit"],
                        style: {
                            color: `rgb(${this.configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`
                        }
                    },
                    opposite: true
                }],
                tooltip: {
                    useHTML: true,
                    outside: true,
                    backgroundColor: `rgb(${this.configColors[USAGE_COLORS.TOOLTIP_BACKGROUND_COLOR]})`,
                    shared: true,
                    borderColor: `rgb(${this.configColors[USAGE_COLORS.ITEMIZATION_LEGEND_COLOR]})`,
                    borderWidth: 1,
                    formatter: function() {
                        return setTooltip(this, self);
                    }
                },
                plotOptions: {
                    series: {
                        maxPointWidth: 50,
                        animation: false,
                        events: {
                            click: function(event) {
                                if (enableDrillDownInsightsUsage && self.props.insightsBillUsageData.mode === TIMESCALE.YEAR) {
                                    self.fetchMonthBillingCycleFromYear(event.point.index);
                                }else if (enableDrillDownInsightsUsage && self.props.insightsBillUsageData.mode === TIMESCALE.MONTH) {
                                    self.fetchDateBillingCycleFromMonth(event.point.index);
                                }else if (enableDrillDownInsightsUsage && self.props.insightsBillUsageData.mode === TIMESCALE.DAY) {
                                    self.fetchDateBillingCycleFromDay(event.point.index);
                                }else {
                                    return;
                                }
                            },
                            legendItemClick: function () {
                                return false
                            }
                        }
                    },
                    column: {
                        stacking: 'normal',
                        cursor: (enableDrillDownInsightsUsage && self.props.insightsBillUsageData.mode !== TIMESCALE.DAY) ? 'pointer' : 'normal',
                        events: {
                            legendItemClick: function () {
                                return false
                            }
                        }
                    },
                    area: {
                        cursor: (enableDrillDownInsightsUsage && self.props.insightsBillUsageData.mode !== TIMESCALE.DAY) ? 'pointer' : 'normal',
                        stacking: 'normal',
                        marker: {
                            enabled: false,
                            symbol: "circle"
                        },
                        events: {
                            legendItemClick: function () {
                                return false
                            }
                        }
                    },
                },
                series: self.props.insightsBillUsageData.insightsUsageHighChartsData
            },
            isUsageChartBCLLoading: false
        });
    }

    render() {
        this.props.translations.data[`USAGE.MODE.HOUR`] = "Hour";
        return (
            <InsightsUsage insightsBillUsageData={this.props.insightsBillUsageData} userIdentityDetails={this.props.userIdentityDetails}
                onModeChange={(mode) => this.onModeChange(mode)} onGraphStyleChange={(style) => this.onGraphStyleChange(style)} onToggleFilterDropdown={(e) => this.onToggleFilterDropdown(e)}
                onToggleGasElectric={() => this.onToggleGasElectric()} onToggleCostEnergy={() => this.onToggleCostEnergy()} onToggleWeather={() => this.onToggleWeather()}
                changeDataToShowOffset={(value) => this.changeDataToShowOffset(value)} showFuelToggle={this.props.configs.data.show_fuel_toggle}
                electricCostUnit={this.props.configs.data.electric_cost_unit} electricEnergyUnit={this.props.configs.data.electric_energy_unit} gasCostUnit={this.props.configs.data.gas_cost_unit}
                gasEnergyUnit={this.props.configs.data.gas_energy_unit} translations={this.props.translations.data} showModeSwitch={this.props.configs.data.showInsightsUsageModeSwitch} configColors={this.configColors}
                showIncludeOnlyUsageDisclaimer={this.props.configs.data.showIncludeOnlyUsageDisclaimer === 'true'}
                currentViewData = { this.props.insightsBillUsageData.mode === TIMESCALE.DAY ? this.props.insightsBillUsageData.dataDayStart : this.props.insightsBillUsageData.dataHourStart } />
        )
    }
}

const mapStateToProps = state => {
    return {
        insightsBillUsageData : state.insightsUsageData,
        userIdentityDetails: state.userIdentityDetails,
        configs: state.configs,
        translations: state.translationsData,
        applianceList: state.appliances.appliancesList,
        queryParams: state.queryParams
    }
}

const mapDispatchToProps = dispatch => {
    return {
        apiError: () => dispatch(apiError()),
        dataNotAvailable: (payload) => dispatch(dataNotAvailable(payload)),
        saveYearData: (payload) => dispatch(saveYearData(payload)),
        saveMonthData: (payload) => dispatch(saveMonthData(payload)),
        saveDayData: (payload) => dispatch(saveDayData(payload)),
        saveHourData: (payload) => dispatch(saveHourData(payload)),
        saveBillingCyclePeriod: (payload) => dispatch(saveBillingCyclePeriod(payload)),
        changeMode: (payload) => dispatch(changeMode(payload)),
        changeGraphStyle: (payload) => dispatch(changeGraphStyle(payload)),
        toggleFilterFropdown: (payload) => dispatch(toggleFilterFropdown(payload)),
        toggleGasElectric: (payload) => dispatch(toggleGasElectric(payload)),
        toggleCostEnergy: (payload) => dispatch(toggleCostEnergy(payload)),
        toggleWeather: (payload) => dispatch(toggleWeather(payload)),
        setInsightsHighchartsData: (payload) => dispatch(setInsightsHighchartsData(payload)),
        changeYearOffset: (payload) => dispatch(changeYearOffset(payload)),
        changeMonthOffset: (payload) => dispatch(changeMonthOffset(payload)),
        changeDayOffset: (payload) => dispatch(changeDayOffset(payload)),
        changeHourOffset: (payload) => dispatch(changeHourOffset(payload)),
        setArrowDisabled: (payload) => dispatch(setArrowDisabled(payload)),
        fetchMonthBillingCycleFromYear: (payload) => dispatch(fetchMonthBillingCycleFromYear(payload)),
        fetchDayBillingCycleFromMonth: (payload) => dispatch(fetchDayBillingCycleFromMonth(payload)),
        fetchHourBillingCycleFromDay: (payload) => dispatch(fetchHourBillingCycleFromDay(payload)),
        setPolling: (payload) => dispatch(setPolling(payload)),
        updateHighChartsObject: (payload) => dispatch(updateHighChartsObject(payload)),
        setHasOngoingBillingCycle: () => dispatch(setHasOngoingBillingCycle()),
        setHasItemizationUnavailable: () => dispatch(setHasItemizationUnavailable()),
        setHasMissingInterval: () => dispatch(setHasMissingInterval()),
        removeDisclaimers: () => dispatch(removeDisclaimers()),
        setDisclaimersVisibility: (payload) => dispatch(setDisclaimersVisibility(payload)),
        setPropsForCostOrConsumptionValues: (options) => dispatch(setPropsForCostOrConsumptionValues(options))
    }
}

export default withLastLocation(connect(mapStateToProps, mapDispatchToProps)(InsightsUsageContainer));
